export const SEND_LOGIN_REQUEST = 'SEND_LOGIN_REQUEST'
export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS'
export const STORE_SELECTED_CUSTOMER = 'STORE_SELECTED_CUSTOMER'
export const CLEAR_AUTH_DATA = 'CLEAR_AUTH_DATA'
export const FETCH_CUSTOMERS_ACTION = 'getCustomers'
